import withStyles from '@mui/styles/withStyles';
import QueryBuilder from '@mui/icons-material/QueryBuilder';
import TodayIcon from '@mui/icons-material/Today';

import { duration as durationService } from '../../../time';

import MetadataWithStyles from './Metadata';
import defaultTranslations from '../../constants/defaultTranslations';

const styles = /* istanbul ignore next */ () => ({
  noWrap: {
    whiteSpace: 'nowrap',
  },
  root: {},
  icon: {},
  text: {},
});

export function MetadataDuration({
  classes = {},
  duration = '',
  shouldNotWrap = false,
  translations = defaultTranslations,
  ...otherProps
}) {
  const { months, hours, minutes } = duration ? durationService.parse(duration) : {};
  const hasDurationData = !!months || !!hours || !!minutes;

  if (!hasDurationData) {
    return null;
  }

  let content = '';

  if (months) {
    content = translations.durationMonths(months);
  } else if (hours) {
    content = translations.durationHours(hours);
  } else {
    content = translations.durationMinutes(minutes);
  }

  const { noWrap, ...otherClasses } = classes;

  return (
    <MetadataWithStyles
      icon={months ? TodayIcon : QueryBuilder}
      accessibilityLabel={translations.duration}
      shouldNotWrap={shouldNotWrap}
      classes={otherClasses}
      {...otherProps}
    >
      <span className={shouldNotWrap ? noWrap : ''}>{content}</span>
    </MetadataWithStyles>
  );
}

/**
 * @deprecated
 * ### Description
 * `MetadataDuration` has been deprecated and replaced by Classify `ProductMetadataDuration`.
 *
 * ### Example
 * ```
 * import ProductMetadataDuration from '@classify/react-product-components/ProductMetadataDuration';
 * ```
 */
export default withStyles(styles)(MetadataDuration);
